import dayjs, { Dayjs } from 'dayjs';

export enum DistributionMode {
  Manual = 'manual',
  Automatic = 'automatic',
}

export type OnboardSurveyDto = {
  projectId: number;
  name: string;
  sequenceNumber: number;
  sendAtWeek: number | null;
  isActive: boolean;
  showOnReportDashboard: boolean;
  lastModified: string;
};

export type OnboardSurveyModel = {
  projectId: number;
  name: string;
  sequenceNumber: number;
  sendAtWeek: number | null;
  isActive: boolean;
  showOnReportDashboard: boolean;
  lastModified: Dayjs;
};

export type LifecycleSurveysDto = {
  onboardSurveys: OnboardSurveyDto[];
  distributionMode: string;
  // TODO(L1S-1161 follow-up): type exit-survey payload when the exit survey page lands.
  exitSurvey: unknown;
};

export type LifecycleSurveysModel = {
  onboardSurveys: OnboardSurveyModel[];
  distributionMode: DistributionMode;
};

export const mapOnboardSurveyDtoToModel = (dto: OnboardSurveyDto): OnboardSurveyModel => ({
  projectId: dto.projectId,
  name: dto.name,
  sequenceNumber: dto.sequenceNumber,
  sendAtWeek: dto.sendAtWeek,
  isActive: dto.isActive,
  showOnReportDashboard: dto.showOnReportDashboard,
  lastModified: dayjs(dto.lastModified),
});

const mapDistributionMode = (value: string | undefined): DistributionMode =>
  value === DistributionMode.Automatic ? DistributionMode.Automatic : DistributionMode.Manual;

export const mapLifecycleSurveysDtoToModel = (dto: LifecycleSurveysDto): LifecycleSurveysModel => ({
  onboardSurveys: (dto.onboardSurveys ?? [])
    .map(mapOnboardSurveyDtoToModel)
    .sort((a, b) => a.sequenceNumber - b.sequenceNumber),
  distributionMode: mapDistributionMode(dto.distributionMode),
});
